export const HHMT_THEME = 'hhmt';
export const REMOX_THEME = 'remox';

export const THEME_STYLESHEET_REFERENCE = {
  [HHMT_THEME]: '/css/hhmt.css',
  HHMT: '/css/hhmt.css',
  [REMOX_THEME]: '/css/remox.css',
  REMOX: '/css/remox.css',
};
